var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconJpg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.867,
    height: 38.897,
    viewBox: "0 0 29.867 38.897",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15781",
    "data-name": "Group 15781",
    transform: "translate(-6.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15780",
    "data-name": "Group 15780",
    transform: "translate(6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M27.674,0H7.516C6.955,0,6.5.455,6.5,1.338V38.2a1.046,1.046,0,0,0,1.016.695H35.351a1.046,1.046,0,0,0,1.016-.695V9.014c0-.483-.065-.639-.179-.754L28.106.179A.614.614,0,0,0,27.674,0Z",
    transform: "translate(-6.5)",
    fill: "#e9e9e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M37.5.151v8.23h8.23Z",
    transform: "translate(-15.968 -0.046)",
    fill: "#d9d7ca"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 3.174,
    cy: 3.174,
    r: 3.174,
    transform: "translate(5.461 6.85)",
    fill: "#3dbbeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M6.5,32.739H36.367V25.1l-6.946-6.6-7.293,7.988L18.32,22.679Z",
    transform: "translate(-6.5 -5.65)",
    fill: "#605fa4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M35.351,50.808H7.516A1.016,1.016,0,0,1,6.5,49.792V39H36.367V49.792A1.016,1.016,0,0,1,35.351,50.808Z",
    transform: "translate(-6.5 -11.911)",
    fill: "#605fa4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15779",
    "data-name": "Group 15779",
    transform: "translate(6.085 29.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M19.543,42.65V48.1a1.743,1.743,0,0,1-.181.831,1.488,1.488,0,0,1-.484.541,1.929,1.929,0,0,1-.7.285,4.015,4.015,0,0,1-.812.081,3.294,3.294,0,0,1-.489-.043,4.155,4.155,0,0,1-.579-.133q-.3-.091-.574-.2a2.1,2.1,0,0,1-.465-.256l.484-.769a1.418,1.418,0,0,0,.271.138q.175.071.385.133c.139.042.285.077.437.109a2.081,2.081,0,0,0,.427.047,1.459,1.459,0,0,0,.8-.194.768.768,0,0,0,.318-.66V42.65Z",
    transform: "translate(-15.26 -42.65)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M25.013,49.854h-1.14v-7h2.013a2.825,2.825,0,0,1,.883.142,2.4,2.4,0,0,1,.783.427,2.231,2.231,0,0,1,.561.688,1.907,1.907,0,0,1,.214.907,2.481,2.481,0,0,1-.181.964,2.015,2.015,0,0,1-.5.727,2.269,2.269,0,0,1-.779.456,3,3,0,0,1-1.006.161h-.845v2.527Zm0-6.135v2.773h1.045a1.241,1.241,0,0,0,.413-.072,1.041,1.041,0,0,0,.375-.233,1.137,1.137,0,0,0,.275-.451,2.136,2.136,0,0,0,.1-.717,1.939,1.939,0,0,0-.047-.394,1.137,1.137,0,0,0-.194-.427,1.151,1.151,0,0,0-.413-.342,1.528,1.528,0,0,0-.7-.138Z",
    transform: "translate(-17.891 -42.713)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M37.2,46.2V48.9a2.045,2.045,0,0,1-.489.451,2.99,2.99,0,0,1-.57.29,2.938,2.938,0,0,1-.617.161,4.059,4.059,0,0,1-.631.049,2.872,2.872,0,0,1-1.154-.228,2.583,2.583,0,0,1-.921-.674,3.182,3.182,0,0,1-.617-1.12,5.533,5.533,0,0,1,0-3.11,3.166,3.166,0,0,1,.617-1.115,2.626,2.626,0,0,1,.926-.679,2.826,2.826,0,0,1,1.149-.233,2.94,2.94,0,0,1,1.063.19,2.594,2.594,0,0,1,.883.57l-.788.7a1.355,1.355,0,0,0-.522-.4,1.564,1.564,0,0,0-.608-.124,1.714,1.714,0,0,0-.67.133,1.434,1.434,0,0,0-.57.451,2.322,2.322,0,0,0-.394.822,4.846,4.846,0,0,0-.152,1.234,5.15,5.15,0,0,0,.147,1.234,2.533,2.533,0,0,0,.38.854,1.618,1.618,0,0,0,.551.494,1.383,1.383,0,0,0,.651.161c.069,0,.163,0,.28-.015a3.41,3.41,0,0,0,.351-.047,2.285,2.285,0,0,0,.337-.09.483.483,0,0,0,.238-.161V46.973H34.886v-.779H37.2Z",
    transform: "translate(-20.367 -42.663)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJpg);
export default __webpack_public_path__ + "static/media/icon-jpg.0c5e06de66b9335c88fc4e73e5ccaf81.svg";
export { ForwardRef as ReactComponent };